// extracted by mini-css-extract-plugin
export default {"wrap":"PlaceholderPage_wrap__aZt8z","title":"PlaceholderPage_title__hYC8T"};